/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 経済条件作成レスポンス
 * @export
 * @interface CreateCondition200Response
 */
export interface CreateCondition200Response {
    /**
     * 経済条件ID
     * @type {number}
     * @memberof CreateCondition200Response
     */
    id: number;
}

/**
 * Check if a given object implements the CreateCondition200Response interface.
 */
export function instanceOfCreateCondition200Response(value: object): value is CreateCondition200Response {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function CreateCondition200ResponseFromJSON(json: any): CreateCondition200Response {
    return CreateCondition200ResponseFromJSONTyped(json, false);
}

export function CreateCondition200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCondition200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
    };
}

export function CreateCondition200ResponseToJSON(json: any): CreateCondition200Response {
    return CreateCondition200ResponseToJSONTyped(json, false);
}

export function CreateCondition200ResponseToJSONTyped(value?: CreateCondition200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
    };
}

